export default "__VITE_ASSET__B9Eh1$mI__"